module.exports = __webpack_public_path__ + "img/PolyU_icon_full.6269f811.png";